var getWindowSize = function getWindowSize() {
  var _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;
  return {
    innerWidth: innerWidth,
    innerHeight: innerHeight
  };
};

export { getWindowSize };